import { serializeLogContext } from './logContext';

const isDev = import.meta.env.DEV;

// Production verbose logging is opt-in via localStorage.DEBUG_OVERLAYQA = '1'.
// Matches the extension's debug.ts pattern so users debugging auto-auth issues
// in production can see [ExtensionAuthBridge], [useAppSession], [api/auth] logs
// without needing a dev build. Read once per call to pick up runtime toggles.
function isVerbose(): boolean {
  if (isDev) return true;
  try {
    return window.localStorage.getItem('DEBUG_OVERLAYQA') === '1';
  } catch {
    return false;
  }
}

export const log = {
  info: (message: string, context?: Record<string, unknown>) => {
    if (isVerbose()) console.log(message, context ?? '');
  },
  warn: (message: string, context?: Record<string, unknown>) => {
    if (isVerbose()) console.warn(message, context ?? '');
  },
  error: (message: string, context?: Record<string, unknown>) => {
    // Serialized (not the raw object): PostHog's console-error autocapture
    // String()-coerces arguments, turning objects into "[object Object]".
    console.error(message, serializeLogContext(context));
  },
};
